import { Component, OnInit } from '@angular/core';
import { LdsUserService } from '../../services/lds-user.service';
import { Router } from '@angular/router';
import { FeaturesetListComponent } from '../../energy-components/featureset-list/featureset-list.component';
import { DeviceSwitchListComponent } from '../device-switch-list/device-switch-list.component'
import { DeviceHeatingListComponent } from '../device-heating-list/device-heating-list.component';

import { EnergyDataService } from '../../energy-data/energy-data.service';
@Component({
    selector: 'lds-devices',
    templateUrl: './devices.component.html',
    styleUrls: ['./devices.component.scss'],
    standalone: false
})
export class DevicesComponent implements OnInit {
  current: String = 'energy';
  public selectedVal: string;
  allDevices = [];
  energyFeatureSets = [];
  rooms = [];

  constructor(private user: LdsUserService, private energyDataService: EnergyDataService) { }

  public onValChange(val: string) {
    this.selectedVal = val;
    this.user.devicePreference = val;
  }

  ngOnInit() {
    // this.user.currentModule = 'Devices';
    // this.rooms = this.user.rooms;
    // this.allDevices = this.user.allDevices;
    // this.selectedVal = this.user.devicePreference;

    // this.user.rooms.forEach(oneRoom => {
    //   let isTrue;
    //   oneRoom.order.forEach(oneRoomOrderId => {
    //     isTrue = this.allDevices.length > 0;
    //   })
    //   oneRoom.show = isTrue ? true : false;
    // })

    this.user.currentModule = 'Devices';
    for (let roomId in this.user.rooms) {
      let room = this.user.rooms[roomId];
      if (room.order.length < 1) {
        continue;
      }

      let name = room.name;
      let featureSets = [];

      for (let i in room.order) {

        let featureSetId = room.order[i];

        let featureSet = this.user.allDevices.find(oneDevice => {
          if (oneDevice.groupId === featureSetId) {
            return oneDevice;
          }
        });

        if(!featureSet){
          continue;
        }

        if (this.user.isEnergyMonitor(featureSet)) {
          continue;
        }

        featureSets.push(featureSetId);
       
      }

      if (featureSets.length > 0) {
        let roomToPush = {
          name: name,
          order: featureSets
        };
        this.rooms.push(roomToPush);
      }



    }


  }

  capitalizeFirstLetter(string): any {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

}
